import globalEventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'

let $modalConfirm = $('#modal_confirm_reset')
let $buttonReset  = $('button.reset')

$buttonReset.click(showModal)

$('button.confirm_reset').click(globalEventBus.emitter('user wants to erase all progression'))
$('button.close_reset').click(hideModal)

$('#modal_confirm_reset').click(hideModal)
$('#modal_confirm_reset .modal_content').click(function (e) {
    e.stopPropagation()
})

globalEventBus.on('menu hidden', hideButton)
globalEventBus.on('menu displayed', showButton)



let fadeDelay = 500
function hideButton () {
    $buttonReset.fadeOut(fadeDelay)
}


function showButton () {
    $buttonReset.fadeIn(fadeDelay)
}



function showModal () {
    $('.blur_on_modal').addClass('blurry')
    hideButton()
    $modalConfirm.fadeIn(fadeDelay)
    globalEventBus.emit('modal reset displayed')
}



function hideModal () {
    $('.blur_on_modal').removeClass('blurry')
    showButton()
    $modalConfirm.fadeOut(fadeDelay)
}


